//Production-specific view; data enrichment follows in the next pass.
import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import {  UiViewHeading, UiTitle, UiView, UiAction } from "../../../../library/layout/Index";
import FormTitle from '../../../../library/form/components/FormTitle';
import FormLauncher from '../../../cmn/docAutomation/FormLauncher';
import FormPaging from '../../../../library/form/components/FormPaging';
import FormSearchCriteria from '../../../../library/form/components/FormSearchCriteria';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormSearchButton from '../../../../library/form/components/FormSearchButton';
import FormWrapper from '../../../../library/form/components/FormWrapper';
import SarasTrans from '../../../../library/notifications/SarasTrans';


const ProductionStockCheckListSystem = (props) => {
    const { formObject, viewData } = props;

    if (!viewData)
        return (null)

    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <span><FormTitle formObject={formObject} value='Stock Check List' /></span>
                </UiTitle>
                <UiAction>
                    <div className='uiFlexBox'>
                        {formObject.childViews.criteriaView && <FormSearchCriteria formObject={formObject} inlineCriteria enableSearch={false} enableGroups={false} enablefav={false}
                            action={{ actionId: "show", refreshMode: "dep",
                                actionParam: { actionType: "stockCheckDisplayCriteria", pId: 1 } }} />}
                        <FormPaging formObject={formObject} />

                        <FormButton formObject={formObject} ksc="r" rowKey=""
                            starIcon={"refresh"}
                            action={{ actionId: "show", actionParam: {},
                            actionMessage:"Refreshing List" }}
                            className="uiActionButton" text={<SarasTrans value="Refresh" />}>
                        </FormButton>
                        <FormWrapper customWrapper="" wrapperClass="" formObject={formObject} rowKey="" action={{ paramName: "addStockItem" }} >
                            <FormSearchButton autofocus formObject={formObject} rowKey="" headerKey='lineItemLink'
                                action={{ actionId: "new", refreshMode:"dep", loadEditorAfterAdd: 1, paramName: "addStockItem", actionParam: {} }}
                                className='uiActionIconButton' placeholder="Barcode or Item Id"
                            />
                        </FormWrapper>
                    </div>
                </UiAction>
            </UiViewHeading>
            
            <div className="listItemDetails phViewContentContainer">
                {
                    Object.values(viewData).sort((a, b) => a.sortKey - b.sortKey).map((row, index) => (
                        <div style={{display:"inline-block"}}>
                            <FormLauncher viewMap={formObject.viewMap} formObject={formObject} 
                                pushFormObject={1}
                                compositionKey={row.rowKey} viewData={row} rowKey={row.rowKey} ></FormLauncher>     
                        </div>
                    ))
                }
            </div>
        </UiView>
    )
}

export default withView(ProductionStockCheckListSystem, "stockCheckListSystem", "stockCheckListSystem,stockCheckListPhysical");
